import { render, staticRenderFns } from "./StatsCard.vue?vue&type=template&id=9b86378a&scoped=true&"
import script from "./StatsCard.vue?vue&type=script&lang=js&"
export * from "./StatsCard.vue?vue&type=script&lang=js&"
import style0 from "./StatsCard.vue?vue&type=style&index=0&id=9b86378a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b86378a",
  null
  
)

export default component.exports